module.exports = __webpack_public_path__ + "img/docIcon.4b267a5.svg";